import { useSDK } from "~hooks";
import { useRouter } from "next/router";
import { Order } from "~graphql/sdk";

const EventTrackingDataKey = "EventTrackingData";

export const useEventTrackingCodes = () => {
  const hasSessionStorage = typeof sessionStorage !== "undefined";
  if (!hasSessionStorage) {
    return;
  }
  const sdk = useSDK();
  const router = useRouter();
  const { query } = router;
  const key = `${EventTrackingDataKey}-${query.eventId}`;

  if (query.tc && !sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, JSON.stringify(query));
    void sdk.onTrackingCodeVisit({
      input: {
        trackingCodeTitle: query.tc as string,
        eventId: query.eventId as string,
      },
    });
  }
};

export const useEventTrackingForOrder = (order: Order) => {
  const hasSessionStorage = typeof sessionStorage !== "undefined";
  if (!hasSessionStorage) {
    return;
  }
  const sdk = useSDK();
  const key = `${EventTrackingDataKey}-${order?.event?.id}`;
  const sessionData = sessionStorage.getItem(key);
  if (sessionData) {
    const trackingData = JSON.parse(sessionData) ?? {
      ["tc"]: null,
      eventId: null,
    };
    if (order?.event?.id == trackingData.eventId) {
      void sdk
        .createOrderToTrackingCodeAssociation({
          input: {
            trackingCodeTitle: trackingData.tc,
            eventId: trackingData.eventId,
            orderId: order.id,
          },
        })
        .then(() => {
          sessionStorage.removeItem(key);
        });
    }
  }
};
